import React from "react";
import { CircularProgress, Typography, Grid, Icon } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import "./sexyLoader.css";
import SvgComponent from "./svgComponent";
import { Dot } from "react-animated-dots";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import "./taskDisplayer.css";
import { lighten } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  loaderText: {
    marginLeft: theme.spacing(0),
  },
  root:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.primary.light, 0.85),
          padding: 5,
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.primary.dark,
          padding: 5,
        },
  iconContainer: {
    width: "44px",
  },
  rocketIcon: {},
}));

const TaskDisplayer = (props) => {
  const classes = useStyles();
  const taskList = useSelector((state) => state.taskList);
  const { t } = useTranslation();

  const taskSelector = () => {
    return taskList.filter((task) => {
      try {
        return (
          (parseInt(JSON.parse(task.MetaData).AccountId) ===
            parseInt(props.AccountID) ||
            props.JetPressGUID === task.JetPressGuid) &&
          task.Progress !== 100 &&
          task.Progress !== -1 &&
          props.Type.includes(task.JobType)
        );
      } catch (error) {
      }
    });
  };

  const generatedTask = taskSelector();

  return generatedTask.length > 0 ? (
    <Grid
      container
      className={classes.root}
      justify="center"
      alignItems="center"
    >
      <Grid className={classes.iconContainer} item>
        <Icon className="animatedIcon">assignment</Icon>
      </Grid>
      <Grid item>
        <Typography className={classes.loaderText} >
          {t(generatedTask[0].JobType)}
          <Dot>.</Dot>
          <Dot>.</Dot>
          <Dot>.</Dot>
        </Typography>
      </Grid>
    </Grid>
  ) : (
    props.children
  );
};
export default TaskDisplayer;
